import Vue from "vue";
import * as SignalR from "@microsoft/signalr";

export function getHubConnection(name: string) {
  const url = Vue.axios.defaults.baseURL + "/" + name;
  const delays = Array<number>();
  for (let i = 0; i < 20; i++) {
    delays.push(5000);
  }
  return new SignalR.HubConnectionBuilder()
    .withUrl(url, { withCredentials: false })
    .withAutomaticReconnect(delays)
    .build();
}
